import { ref, onMounted } from 'vue';
import { useRest } from '@/composables/useRest'; 

export function useProsecutor() {
  const prosecutorUserTypes = ref([]);
  const { get } = useRest();

  const cleanData = (userTypes) => {
    return userTypes.map(userType => userType.Nombre);
  };

  const fetchProsecutorUserTypes = async () => {
    const url = process.env.VUE_APP_BACKEND_ENVIRONMENT + "/parametros/tipo-usuario?TipoUsuarioPadre=Fiscal";
    const result = await get({ url });
    prosecutorUserTypes.value = cleanData(result.data.data);
  };

  onMounted(() => {
    fetchProsecutorUserTypes();
  });

  return {
    prosecutorUserTypes,
  };
}
